export const PURPOSES = [
  { id: 1, name: "à vendre" },
  { id: 2, name: "à louer" },
  { id: 3, name: "vente en viager" },
];

export const PURPOSE_STATUS = [
  { id: 1, name: "à vendre", purposeId: 1 },
  { id: 2, name: "à louer", purposeId: 2 },
  { id: 3, name: "vendu", purposeId: 1 },
  { id: 4, name: "loué", purposeId: 2 },
  { id: 5, name: "option v.", purposeId: 1 },
  { id: 6, name: "option l.", purposeId: 2 },
  { id: 8, name: "retiré v.", purposeId: 1 },
  { id: 9, name: "retiré l.", purposeId: 2 },
  { id: 10, name: "suspendu v.", purposeId: 1 },
  { id: 11, name: "suspendu l.", purposeId: 2 },
  { id: 12, name: "option prop. v.", purposeId: 1 },
  { id: 13, name: "option prop. l.", purposeId: 2 },
  { id: 14, name: "vendu avec cond. suspensive", purposeId: 1 },
  { id: 15, name: "à vendre", purposeId: 3 },
  { id: 16, name: "option v.", purposeId: 3 },
  { id: 17, name: "vendu", purposeId: 3 },
  { id: 19, name: "prospection", purposeId: 1 },
  { id: 20, name: "préparation", purposeId: 1 },
  { id: 21, name: "réservé", purposeId: 1 },
  { id: 22, name: "compromis", purposeId: 1 },
  { id: 23, name: "prospection location", purposeId: 2 },
  { id: 24, name: "estimation v.", purposeId: 1 },
  { id: 25, name: "estimation l.", purposeId: 2 },
  { id: 26, name: "estimation r.v.", purposeId: 3 },
  { id: 27, name: "en preparation (location)", purposeId: 2 },
  { id: 28, name: "en preparation (v. en viager)", purposeId: 3 },
];

export const CATEGORIES = [
  { id: 1, name: "maison" },
  { id: 2, name: "appartement" },
  { id: 3, name: "terrain" },
  { id: 4, name: "bureau" },
  { id: 5, name: "commerce" },
  { id: 6, name: "industriel" },
  { id: 7, name: "garage / parking" },
];

export const ESTATE_DISPLAY_STATUS = [
  {
    id: 1,
    name: "Hors ligne",
  },
  {
    id: 2,
    name: "En ligne",
  },
  {
    id: 3,
    name: "Bien du mois",
  },
  {
    id: 4,
    name: "Réalisation",
  },
];

export const ESTATE_STATUS = [
  {
    id: 1,
    name: "Active",
  },
];

export const SUBCATEGORIES = [
  { id: 1, name: "Maison", categoryId: 1 },
  { id: 2, name: "Bien exceptionnel", categoryId: 1 },
  { id: 3, name: "Immeuble à appartements", categoryId: 1 },
  { id: 4, name: "Ferme", categoryId: 1 },
  { id: 5, name: "Bungalow", categoryId: 1 },
  { id: 6, name: "Garage (fermé)", categoryId: 1 },
  { id: 7, name: "Bel-étage", categoryId: 1 },
  { id: 8, name: "Immeuble mixte", categoryId: 1 },
  { id: 9, name: "Fermette", categoryId: 1 },
  { id: 10, name: "Chalet", categoryId: 1 },
  { id: 12, name: "Maison de maître", categoryId: 1 },
  { id: 13, name: "Villa", categoryId: 1 },
  { id: 14, name: "Château", categoryId: 1 },
  { id: 16, name: "Autre", categoryId: 1 },
  { id: 17, name: "Appartement", categoryId: 2 },
  { id: 18, name: "Duplex", categoryId: 2 },
  { id: 19, name: "Penthouse", categoryId: 2 },
  { id: 20, name: "Flat", categoryId: 2 },
  { id: 21, name: "Studio", categoryId: 2 },
  { id: 22, name: "Triplex", categoryId: 2 },
  { id: 23, name: "Loft", categoryId: 2 },
  { id: 25, name: "Rez-de-chaussée", categoryId: 2 },
  { id: 26, name: "Terrain à bâtir", categoryId: 3 },
  { id: 27, name: "Champ", categoryId: 3 },
  { id: 28, name: "Zone verte", categoryId: 3 },
  { id: 29, name: "Plaine de jeu", categoryId: 3 },
  { id: 30, name: "Prairie", categoryId: 3 },
  { id: 31, name: "Terrain agricole", categoryId: 3 },
  { id: 32, name: "Bois", categoryId: 3 },
  { id: 33, name: "Verger", categoryId: 3 },
  { id: 34, name: "Terrain", categoryId: 3 },
  { id: 35, name: "Immeuble de bureaux", categoryId: 4 },
  { id: 36, name: "Villa", categoryId: 4 },
  { id: 37, name: "Immeuble à usage multiple", categoryId: 4 },
  { id: 38, name: "Maison de maître", categoryId: 4 },
  { id: 40, name: "Bureaux", categoryId: 4 },
  { id: 41, name: "Immeuble", categoryId: 4 },
  { id: 42, name: "Commerce individuel", categoryId: 5 },
  { id: 43, name: "Taverne", categoryId: 5 },
  { id: 44, name: "Centre commercial", categoryId: 5 },
  { id: 45, name: "Immeuble à usage multiple", categoryId: 5 },
  { id: 46, name: "Immeuble industriel", categoryId: 6 },
  { id: 47, name: "Immeuble a usage multiple", categoryId: 6 },
  { id: 48, name: "Parking extérieur", categoryId: 7 },
  { id: 49, name: "Parking intérieur", categoryId: 7 },
  { id: 50, name: "Garage (ouvert)", categoryId: 7 },
  { id: 51, name: "Garage (ferme)", categoryId: 7 },
  { id: 52, name: "Carport", categoryId: 7 },
  { id: 53, name: "Entrepôt", categoryId: 6 },
  { id: 54, name: "Horeca", categoryId: 5 },
  { id: 55, name: "Alimentation", categoryId: 5 },
  { id: 56, name: "Librairie/tabac/fleurs", categoryId: 5 },
  { id: 57, name: "Vetements/textiles", categoryId: 5 },
  { id: 58, name: "Autos / bicyclettes", categoryId: 5 },
  { id: 59, name: "Coiffure/esthetique", categoryId: 5 },
  { id: 60, name: "Autres", categoryId: 5 },
  { id: 61, name: "Autres", categoryId: 6 },
  { id: 62, name: "Autres", categoryId: 2 },
  { id: 63, name: "Autres", categoryId: 3 },
  { id: 64, name: "Autres", categoryId: 4 },
  { id: 65, name: "Magasin de peripherie", categoryId: 5 },
  { id: 66, name: "Autres", categoryId: 7 },
  { id: 69, name: "Appartements à usage multiple", categoryId: 2 },
  { id: 70, name: "Maison de campagne", categoryId: 1 },
  { id: 71, name: "Maison de caractère", categoryId: 1 },
  { id: 72, name: "App. dans maison de caractère", categoryId: 2 },
  { id: 73, name: "Rez-de-ch. avec jardin", categoryId: 2 },
  { id: 74, name: "Appartement avec jardin", categoryId: 2 },
  { id: 76, name: "Usage multiple", categoryId: 4 },
  { id: 77, name: "Archives", categoryId: 4 },
  { id: 78, name: "Terrain industriel", categoryId: 3 },
  { id: 79, name: "Usine", categoryId: 6 },
  { id: 80, name: "Atelier", categoryId: 6 },
  { id: 81, name: "Frigo", categoryId: 6 },
  { id: 82, name: "Bureaux & entrepôts", categoryId: 6 },
  { id: 83, name: "Bureaux", categoryId: 6 },
  { id: 84, name: "Débarras - archives", categoryId: 7 },
  { id: 85, name: "Garage + débarras", categoryId: 7 },
  { id: 86, name: "Garage double", categoryId: 7 },
  { id: 87, name: "Maison de vacances", categoryId: 1 },
  { id: 88, name: "Terrain  pour pme", categoryId: 3 },
  { id: 89, name: "Maison unifamiliale", categoryId: 1 },
  { id: 90, name: "Villa jumelée", categoryId: 1 },
  { id: 93, name: "Chambre étudiant", categoryId: 2 },
  { id: 94, name: "App. sous toit", categoryId: 2 },
  { id: 95, name: "Service flats", categoryId: 2 },
  { id: 96, name: "Maison vente sur plan", categoryId: 1 },
  { id: 97, name: "Appartement vente sur plan", categoryId: 2 },
  { id: 98, name: "Centre de retrait", categoryId: 5 },
  { id: 99, name: "Bed & breakfast", categoryId: 5 },
  { id: 101, name: "Boulangerie", categoryId: 5 },
  { id: 102, name: "Sandwicherie", categoryId: 5 },
  { id: 103, name: "Café / bar", categoryId: 5 },
  { id: 104, name: "Café / bar / room", categoryId: 5 },
  { id: 105, name: "Café / restaurant", categoryId: 5 },
  { id: 106, name: "Café / restaurant / rooms", categoryId: 5 },
  { id: 107, name: "Cafetaria / snackbar", categoryId: 5 },
  { id: 108, name: "Camping / loisirs", categoryId: 5 },
  { id: 109, name: "Restaurant chinois", categoryId: 5 },
  { id: 110, name: "Espace horeca casco", categoryId: 5 },
  { id: 111, name: "Catering", categoryId: 5 },
  { id: 112, name: "Coffeeshop", categoryId: 5 },
  { id: 113, name: "Club", categoryId: 5 },
  { id: 114, name: "Centre de jour", categoryId: 5 },
  { id: 115, name: "Centre de danse", categoryId: 5 },
  { id: 116, name: "Confiserie", categoryId: 5 },
  { id: 117, name: "Discothèque / dancing", categoryId: 5 },
  { id: 118, name: "Discotheek / nachtcafé", categoryId: 5 },
  { id: 119, name: "Brasserie", categoryId: 5 },
  { id: 120, name: "Centre de jeux", categoryId: 5 },
  { id: 121, name: "Pâtisserie", categoryId: 5 },
  { id: 122, name: "Grand-café", categoryId: 5 },
  { id: 123, name: "Coffeeshop / cafetaria", categoryId: 5 },
  { id: 124, name: "Loungeclub", categoryId: 5 },
  { id: 125, name: "Bateau salle de fête", categoryId: 5 },
  { id: 126, name: "Partycentrum", categoryId: 5 },
  { id: 127, name: "Pension", categoryId: 5 },
  { id: 128, name: "Hotel", categoryId: 5 },
  { id: 129, name: "Hotel / restaurant", categoryId: 5 },
  { id: 130, name: "Hotel / restaurant / salles", categoryId: 5 },
  { id: 131, name: "Hostel", categoryId: 5 },
  { id: 133, name: "Glacier", categoryId: 5 },
  { id: 134, name: "Lunchroom", categoryId: 5 },
  { id: 135, name: "Autres horeca", categoryId: 5 },
  { id: 136, name: "Pizzeria", categoryId: 5 },
  { id: 137, name: "Pizzeria + delivery", categoryId: 5 },
  { id: 138, name: "Restaurant", categoryId: 5 },
  { id: 139, name: "Restaurant / salles", categoryId: 5 },
  { id: 140, name: "Shoarma / grillroom", categoryId: 5 },
  { id: 141, name: "Shoarma / grillroom + delivery", categoryId: 5 },
  { id: 142, name: "Camion snack & fish", categoryId: 5 },
  { id: 143, name: "Pavillon de plage", categoryId: 5 },
  { id: 144, name: "Sauna", categoryId: 5 },
  { id: 145, name: "Tearoom", categoryId: 5 },
  { id: 146, name: "Traiteur", categoryId: 5 },
  { id: 147, name: "Fish shop", categoryId: 5 },
  { id: 148, name: "Wellness", categoryId: 5 },
  { id: 149, name: "Restaurant de route", categoryId: 5 },
  { id: 150, name: "Wok restaurant", categoryId: 5 },
  { id: 151, name: "Magasin", categoryId: 5 },
  { id: 152, name: "Salle de fête", categoryId: 5 },
  { id: 154, name: "Maison de repos", categoryId: 1 },
  { id: 155, name: "Villa exceptionnelle", categoryId: 4 },
  { id: 156, name: "Appartement exceptionnel", categoryId: 2 },
  { id: 157, name: "Cave", categoryId: 7 },
  { id: 158, name: "Cabin", categoryId: 1 },
  { id: 159, name: "Terrain pour entreprises", categoryId: 3 },
  { id: 160, name: "Chambre", categoryId: 2 },
  { id: 161, name: "Terrain à bâtir (projets)", categoryId: 3 },
  { id: 162, name: "Rez commercial", categoryId: 5 },
  { id: 163, name: "Snack", categoryId: 5 },
  { id: 164, name: "Immeuble commercial", categoryId: 5 },
  { id: 165, name: "Résidences-services", categoryId: 2 },
  { id: 167, name: "Local à vélo", categoryId: 7 },
  { id: 168, name: "Immeuble polyvalent", categoryId: 6 },
  { id: 169, name: "Unité pme", categoryId: 6 },
  { id: 170, name: "Parking", categoryId: 7 },
  { id: 171, name: "Imm. mixte bur + rés.", categoryId: 4 },
  { id: 172, name: "Imm. mixte rés. + bur.", categoryId: 4 },
  { id: 173, name: "Property on a canal - nl only", categoryId: 1 },
  { id: 174, name: "Chalet/stacaravan - nl only", categoryId: 1 },
  { id: 175, name: "Car where can live - nl only", categoryId: 1 },
  { id: 176, name: "Bovenwoning - nl only", categoryId: 2 },
  { id: 177, name: "Benedenwoning - nl only", categoryId: 2 },
  { id: 178, name: "Maisonnette - nl only", categoryId: 2 },
  { id: 179, name: "Galerijflat - nl only", categoryId: 2 },
  { id: 180, name: "Portiekflat - nl only", categoryId: 2 },
  { id: 181, name: "Portiekwoning - nl only", categoryId: 2 },
  { id: 182, name: "Dubbel benedenhuis - nl only", categoryId: 2 },
  { id: 183, name: "Tussenverdieping - nl only", categoryId: 2 },
  { id: 184, name: "Rez-de-chaussée", categoryId: 1 },
  { id: 185, name: "Maison du vignoble", categoryId: 1 },
];

export const yesNoOptions = [
  { value: "true", label: "Oui" },
  { value: "false", label: "Non" },
];

export const digitalAdvertisingOptions1 = [
  { id: 0, name: "Immoweb" },
  { id: 13, name: "Immovlan" },
  { id: 0, name: "Zimmo" },
];
export const digitalAdvertisingOptions2 = [
  { id: 8, name: "Facebook" },
  { id: 15, name: "Instagram" },
  { id: 19, name: "LinkedIn" },
];
export const digitalAdvertisingOptions3 = [
  { id: 23, name: "Tik Tok" },
  { id: 0, name: "Autres" },
];

export const SIGNATURES = [
  {
    offices: [2468, 14765],
    values: [
      {
        name: "Philippe Mestach",
        role: "Directeur - Immobilier Neuf - Bruxelles",
      },
      {
        name: "Charlotte Moreau de Bellaing",
        role: "Responsable Stratégie & Développement",
      },
    ],
  },
  {
    offices: [7674],
    values: [
      {
        name: "Nicolas Wedenig",
        role: "Directeur - Brabant Wallon",
      },
    ],
  },
  {
    offices: [2420],
    values: [
      {
        name: "Philippe Taillet",
        role: "Directeur - Namur",
      },
    ],
  },
];

export const DOCUMENT_TYPES = [
  { id: 1, name: "Rapport promoteur", hasTemplate: true, isActive: false },
  { id: 2, name: "Rapport promoteur V2", hasTemplate: true, isActive: false },
  { id: 3, name: "Rapport promoteur", hasTemplate: true, isActive: true },
  { id: 4, name: "Amalgame", hasTemplate: false, isActive: true },
  { id: 5, name: "Bonjour Wavre", hasTemplate: false, isActive: true },
  { id: 6, name: "Essentielle", hasTemplate: false, isActive: true },
  { id: 7, name: "Eventail", hasTemplate: false, isActive: true },
  { id: 8, name: "Facebook", hasTemplate: false, isActive: true },
  { id: 9, name: "Facebook Carroussel", hasTemplate: false, isActive: true },
  { id: 10, name: "Google", hasTemplate: false, isActive: true },
  { id: 11, name: "Google Ads", hasTemplate: false, isActive: true },
  { id: 12, name: "Google business", hasTemplate: false, isActive: true },
  { id: 13, name: "Immovlan", hasTemplate: false, isActive: true },
  { id: 14, name: "Info Wavre", hasTemplate: false, isActive: true },
  { id: 15, name: "Instagram", hasTemplate: false, isActive: true },
  { id: 16, name: "Instagram storie", hasTemplate: false, isActive: true },
  { id: 17, name: "Le Soir", hasTemplate: false, isActive: true },
  { id: 18, name: "La Libre", hasTemplate: false, isActive: true },
  { id: 19, name: "Linkedin", hasTemplate: false, isActive: true },
  { id: 20, name: "mailings", hasTemplate: false, isActive: true },
  { id: 21, name: "Paris Match", hasTemplate: false, isActive: true },
  { id: 22, name: "Panneaux", hasTemplate: false, isActive: true },
  { id: 23, name: "Tiktok", hasTemplate: false, isActive: true },
  { id: 24, name: "Toutes boites", hasTemplate: false, isActive: true },
  { id: 25, name: "TTB", hasTemplate: false, isActive: true },
  { id: 26, name: "Wolumag", hasTemplate: false, isActive: true },
  { id: 27, name: "Woluinfo", hasTemplate: false, isActive: true },
  { id: 28, name: "Logo promoteur", hasTemplate: false, isActive: true },
  { id: 29, name: "Pinterest", hasTemplate: false, isActive: true },
  { id: 30, name: "Wolvendael", hasTemplate: false, isActive: true },
  { id: 31, name: "Vivre à Lasne", hasTemplate: false, isActive: true },
  { id: 32, name: "Olln", hasTemplate: false, isActive: true },
  { id: 33, name: "Almanach", hasTemplate: false, isActive: true },
];
